import { Component,  Input, Output, EventEmitter } from '@angular/core';
import { Performer, SocialLink } from 'globals/store/performers.data';
import { Sponsor } from 'globals/store/sponsors.data';
import { Label, Ranking } from 'globals/store/events.data';
import { PublicEventInfo, PublicTimelineItem } from 'globals/store/public.model';
import { publicHelpers } from './../../helpers/public-helpers';
import { Exhibitor } from 'globals/store/exhibitors.data';
import { PublishTimelineItemComponent } from '../publish-timeline/publish-timeline-item';
import { CommonModule } from '@angular/common';
import { LabelsViewComponent } from '../label-marker/labels-view.component';
import { PhotoComponent } from '../photo';
import { IconComponent } from '../icon/icon.component';
import { SocialLinksComponent } from '../social-links/social-links.component';

@Component({
    selector: 'entity-profile',
    template: `
<div class="profile-holder">
  <div class="back-button" (click)="goBack.emit()" *ngIf="!!backLabel"><icon icon="ARROW_BACK"></icon>{{ backLabel }}</div>
  <div class="profile-boxes">
    <div class="entity-images" [ngClass]="{sponsor: !!sponsor || !!exhibitor}" *ngIf="!hideImages">
      <ng-container *ngIf="!!performer">
        <photo class="performer-photo" [size]="120" [data]="{title: performer.name, photoURL:performer.fullPhotoUrl || performer.photoUrl}"></photo>
        <img *ngIf="!!performer.logoUrl" class="performer-logo" [src]="logoUrl">
      </ng-container>
      <ng-container *ngIf="!!sponsor || !!exhibitor">
        <img class="sponsor-logo" [src]="logoUrl">
      </ng-container>
    </div>
    <div class="entity-profile" [ngClass]="{sponsor: !!sponsor, noLogo: !performer && !logoUrl }" >
      <div class="entity-name">{{ name }}</div>
      <div class="performer-line" *ngIf="performer?.line1">{{ performer.line1 }}</div>
      <div class="performer-line" *ngIf="exhibitor?.locationText">{{ exhibitor.locationText }}</div>
      <div class="performer-line" *ngIf="performer?.line2">{{ performer.line2 }}</div>
      <labels-view class="profile-labels" *ngIf="(labels?.length && !hideLabels) || sponsorType"
        [labelMap]="labelMap"
        [labels]="hideLabels ? null : labels"
        [sponsorType]="sponsorType"
      ></labels-view>
      <social-links *ngIf="social?.length" [ngClass]="{sponsor: !!sponsor || !!exhibitor}" [socialLinks]="social"></social-links>
      <div *ngIf="!!description" class="description" [innerHTML]="helpers.strWithBreak(description)"></div>
      <button *ngIf="!!callToAction && !!callToActionUrl" class="call-to-action" mat-button color="primary" (click)="helpers.goToUrl($event, callToActionUrl)">{{ callToAction | uppercase }}</button>

    </div>
  </div>
  <ng-container *ngIf="!!sessions?.length">
    <hr class="divider" />
    <div class="sessions-holder" >
      <div class="sessions-title" *ngIf="sessionsTitle">{{ sessionsTitle }}</div>
      <ng-container *ngFor="let session of sessions; trackBy: trackByIndex">
        <div class="session-date-time">{{ session.start }} - {{ session.end}}, {{ session.displayDate ? session.displayDate : session.session_date === session.on_day ? 'Day '+session.on_day : (session.session_date | date:"EEEE d LLLL y")  }}</div>
        <publish-timeline-item
          [startingCollapseState]="'collapse'"
          [session]="session"
          [joiEvent]="joiEvent"
          [hideTimeLine]="true"
          [programText]="programTexts[session.program.id]"
        ></publish-timeline-item>
      </ng-container>
    </div>
  </ng-container>
  
</div>
`,
    styleUrls: ['program-entity-profile.scss'],
    standalone: true,
    imports: [PublishTimelineItemComponent, SocialLinksComponent, CommonModule, LabelsViewComponent, PhotoComponent,IconComponent]
})
export class EntityProfileComponent {
  @Input() performer: Performer = null
  @Input() sponsor: Sponsor = null
  @Input() exhibitor: Exhibitor = null
  @Input() name: string
  @Input() hideLabels: boolean
  @Input() hideImages: boolean
  @Input() labels: string[]
  @Input() sponsorType: Ranking
  @Input() description: string
  @Input() callToAction: string
  @Input() callToActionUrl: string
  @Input() social: SocialLink[]
  @Input() joiEvent: PublicEventInfo
  @Input() labelMap: { [id: string]: Label }
  @Input() sessions: PublicTimelineItem[] = []
  @Input() logoUrl: string
  @Input() backLabel
  @Input() sessionsTitle
  @Input() programTexts = {}
  @Output() goBack: EventEmitter<void> = new EventEmitter()

  helpers = publicHelpers

  trackByIndex(index) {
    return index
  }
}




